/** Read searched location from localStorage payload (GlobalSearch, PopularCities, etc.) */
export const getStoredSearchLocation = (stored) => {
  if (!stored) return '';

  if (stored.searchParams?.location) {
    return String(stored.searchParams.location).trim();
  }

  if (typeof stored.query === 'string' && stored.query.trim()) {
    return stored.query.trim();
  }

  if (stored.query && typeof stored.query === 'object') {
    const fromQuery = stored.query.city || stored.query.input;
    if (fromQuery) return String(fromQuery).trim();
  }

  return '';
};

/** Normalize API search response with a consistent query + searchParams.location */
export const buildStoredSearchPayload = (json, location, searchParams = {}) => {
  const loc = String(location || '').trim();
  return {
    ...json,
    query: {
      city: loc,
      input: loc,
    },
    searchParams: {
      ...searchParams,
      location: loc,
    },
    searchPlace: json?.searchPlace || null,
  };
};
